import { styled } from 'styled-components'

export const StyledPrivateLayout = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  width: 100vw;
  height: 100vh;
`

export const StyledPublicLayout = styled.main`
  display: flex;
  flex-direction: column;

  width: 100vw;
  min-height: 100vh;
`
